// Auto-generated version file
// This file is generated during the build process
window.APP_VERSION = {
    version: '0.9.22',
    gitCommit: '6a7ebe9894cdbe2c5938c6d04bf24a13fdbff445',
    buildDate: '2026-08-12T11:15:30.317Z',
    environment: 'production'
};

// Update version in footer
document.addEventListener('DOMContentLoaded', function() {
    const versionElement = document.getElementById('appVersion');
    if (versionElement) {
        versionElement.textContent = window.APP_VERSION.version + ' (' + window.APP_VERSION.gitCommit.substring(0, 7) + ')';
    }
});